<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-header>
				<div class="md-title card-header">Which give should be included?</div>
			</md-card-header>
			<md-card-content>

				<div v-for="(give, index) in ask.gives" :key="index">
					<table>
						<tr>
							<td>
								<font-awesome-icon class='selector' v-if="index != selected" icon="square" @click="toggle(index)" />
								<font-awesome-icon class='selector' v-if="index == selected" icon="check-square" @click="toggle(index)" />
							</td>
							<td class='action'>
								Action: <b>{{give.action}}</b>,
							</td>
							<td>
								<i>{{give.emailSent ? "Already sent" : "Not yet sent"}}</i>
							</td>
							<td class='insight'>
								{{give.insight}}
							</td>
						</tr>
					</table>
				</div>
			</md-card-content>
		</md-card>

		<md-card class="mt-30">
			<md-card-header>
				<div class="md-title card-header">Preview connect email for: <b>{{ ask.subject }}</b></div>
			</md-card-header>
			<md-card-content>
				<md-card>
					<md-card-header>
						Subject: {{email.subject}}
					</md-card-header>
					<md-card-content>
						<md-tabs>
							<md-tab id="tab-html" md-label="HTML">
								<div id='previewHTML'>HTML preview...</div>
							</md-tab>
							<md-tab id="tab-text" md-label="Text">
								<div id='previewText' class='text-preview'>Text preview...</div>
							</md-tab>
							<md-tab id="tab-attachments" md-label="Attachments">
								<div id='previewAttachments'><i>(none)</i></div>
							</md-tab>
						</md-tabs>
					</md-card-content>
				</md-card><br />
				<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import MultiMemberPicker from "./MultiMemberPicker";
import ActivityLog from "./ActivityLog";
import Comments from "./Comments";
import AskFeedback from "./AskFeedback";

export default {
  name: "SendEmail",
  props: ["template"],
  components: {
    MultiMemberPicker,
    ActivityLog,
    Comments,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      action: "get-feedback",
      ask: {},
      email: { subject: "", html: "", text: "" },
      selected: 0,
      advisors: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData: async function() {
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(ask => {
        this.ask = ask.data;
        this.previewEmail();
        if (this.ask) {
          this.ask.recommendedAdvisors.map(async id => {
            await this.api.get(`members/${id}`).then(member => {
              this.advisors.push(member.data);
            });
          });
        }
      });
    },
    previewEmail: async function() {
      await this.api
        .get(
          `asks/${this.$route.params.ask_id}/preview_email/${this.template}?give=${
            this.selected
          }`
        )
        .then(preview => {
          this.email = preview.data;
          window.previewHTML.innerHTML = this.email.html;
          window.previewText.innerText = this.email.text;
        });
    },
    toggle: function(index) {
      this.selected = index;
      this.previewEmail();
    },
    updateSelected: function(selectedList) {
      this.selectedAdvisors = selectedList;
    },
    doInteraction: async function() {
      await this.api
        .post(`asks/${this.ask._id}/${this.action}`, {
          give: this.selected,
          recipients: this.advisors
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractRequestFeedback.vue